import { create } from 'zustand';
import type { ConnectionState } from '@/types';

interface ConnectionStore {
  wsState: 'idle' | 'connecting' | 'connected' | 'disconnected';
  rtcState: ConnectionState;
  isRelay: boolean;
  error: string | null;

  setWsState: (s: ConnectionStore['wsState']) => void;
  setRtcState: (s: ConnectionState) => void;
  setIsRelay: (v: boolean) => void;
  setError: (e: string | null) => void;
}

export const useConnectionStore = create<ConnectionStore>((set) => ({
  wsState: 'idle',
  rtcState: 'idle',
  isRelay: false,
  error: null,

  setWsState: (wsState) => set({ wsState }),
  setRtcState: (rtcState) => set({ rtcState }),
  setIsRelay: (isRelay) => set({ isRelay }),
  setError: (error) => set({ error }),
}));
